import { createAction } from 'lib/store-utils';
import { Overview } from 'type/models';

export const BOX_OVERVIEW_DATA_REQUEST = createAction('Overview / get page data request');
export const BOX_OVERVIEW_GET_OVERVIEW_SUCCESS = createAction<Overview>('Overview / Get overview data success');

export const BOX_OVERVIEW_FETCH_DATA_REQUEST = createAction('Manager dashboard / Update overview data request');
export const BOX_OVERVIEW_FETCH_DATA_SUCCESS = createAction<Overview>('Manager dashboard / Update overview data success');
